const locale = {
    placeholder: 'Velg tid',
};
export default locale;



// WEBPACK FOOTER //
// ./components/time-picker/locale/nb_NO.tsx